/*
 * @Author: Dong
 * @Date: 2022-01-12 13:48:48
 * @LastEditors: Dong
 * @LastEditTime: 2022-05-23 14:01:03
 */
import React, { PureComponent } from 'react';
import { Input, Tree } from 'sup-ui';

const treeToList = (tree, list = []) => {
  tree.forEach((item) => {
    const { children, ...other } = item;
    list.push({ ...other });
    if (children && children.length !== 0) {
      return treeToList(children, list);
    }
  });

  return list;
};

const getParentKey = (value, tree) => {
  let parentKey;
  tree.forEach((item) => {
    if (item.children && item.children.length !== 0) {
      if (item.children.some((o) => o.value === value)) {
        parentKey = item.value;
      } else if (getParentKey(value, item.children)) {
        parentKey = getParentKey(value, item.children);
      }
    }
  });

  return parentKey;
};

const { Search } = Input;
const { TreeNode } = Tree;

class TreeSelect extends PureComponent {
  state = {
    searchValue: '',
    expandedKeys: [],
    options: [],
    dataList: [],
    autoExpandParent: true,
  }

  componentDidMount() {
    const { item: { filterOptions } } = this.props;
    this.initData(filterOptions);
  }

  // 树转列表（筛选用）
  initData = (filterOptions) => {
    if (!filterOptions || filterOptions.length === 0) return;

    const dataList = treeToList(filterOptions);
    const expandedKeys = dataList.map((item) => item.value);

    this.setState({
      dataList,
      expandedKeys,
      options: filterOptions,
    });
  }

  onExpand = (expandedKeys) => {
    this.setState({
      expandedKeys,
      autoExpandParent: false,
    });
  };

  onChange = (e) => {
    const { value } = e.target;
    const { dataList, options } = this.state;
    const expandedKeys = dataList
      .map((item) => {
        if (item.label.indexOf(value) > -1) {
          return getParentKey(item.value, options);
        }
        return null;
      })
      .filter((item, i, self) => item && self.indexOf(item) === i);

    this.setState({
      searchValue: value,
      expandedKeys,
      autoExpandParent: true,
    }, () => {
      const firstMatchNode = dataList.find((item) => item.label.includes(value));
      if (firstMatchNode?.value && this[firstMatchNode.value]?.scrollIntoView) {
        this[firstMatchNode.value].scrollIntoView();
      }
    });
  };

  loop = (data) => data.map((item) => {
    const { label, value, disabled, children } = item;
    const { searchValue } = this.state;
    const index = label.indexOf(searchValue);
    const beforeStr = label.substr(0, index);
    const afterStr = label.substr(index + searchValue.length);
    const title = index > -1 ? (
      <span ref={(ref) => { this[value] = ref; }}>
        {beforeStr}
        <span style={{ color: '#f50' }}>{searchValue}</span>
        {afterStr}
      </span>
    ) : (
      <span ref={(ref) => { this[value] = ref; }}>{label}</span>
    );
    if (children && children.length !== 0) {
      return (
        <TreeNode
          title={title}
          key={value}
          disabled={disabled}
        >
          {this.loop(item.children)}
        </TreeNode>
      );
    }
    return (
      <TreeNode
        title={title}
        key={value}
        disabled={disabled}
      />
    );
  });

  render() {
    const { expandedKeys, options, autoExpandParent, searchValue } = this.state;
    const { contextLocale, prefixCl, item: { title }, setSelectedKeys, selectedKeys } = this.props;

    return (
      <div className={`${prefixCl}-list`}>
        <Search
          allowClear
          className={`${prefixCl}-tree-search ${searchValue ? `${prefixCl}-tree-search-clear` : ''}`}
          placeholder={contextLocale['SupTable.pleaseInput'] + title}
          value={searchValue}
          onChange={this.onChange}
        />
        <Tree
          className={`${prefixCl}-tree`}
          multiple
          blockNode
          motion={{}}
          autoExpandParent={autoExpandParent}
          expandedKeys={expandedKeys}
          selectedKeys={selectedKeys}
          onSelect={setSelectedKeys}
          onExpand={this.onExpand}
        >
          {this.loop(options)}
        </Tree>
      </div>
    );
  }
}

export default TreeSelect;
